import { render } from "./TechnicalInfo.vue?vue&type=template&id=20c88d77"
import script from "./TechnicalInfo.vue?vue&type=script&lang=js"
export * from "./TechnicalInfo.vue?vue&type=script&lang=js"
script.render = render

export default script